import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class StartSpinState extends BaseState {
    public begin() {
        const isBuyBonusSpin = !!this._model.isBuyBonusPending
        const currentSpinType = String(this._model.spinData?.spin_type || '').toLowerCase()
        const nextRoundType = String(this._model.spinData?.next_round_type || '').toLowerCase()
        const nextRespinsLeft = Number(this._model.spinData?.respins_left ?? 0)
        const shouldEnterRespinRound =
            (nextRoundType === 'respins' || nextRoundType === 'respin') &&
            Number.isFinite(nextRespinsLeft) &&
            nextRespinsLeft > 0
        const shouldPlayHoldAndWinTransition = shouldEnterRespinRound && currentSpinType !== 'respin'
        const spinBet = isBuyBonusSpin && this._model.bonusBuyBet ? this._model.bonusBuyBet : this._model.currentSpinBet

        this._model.resetSpinState()
        this._model.spinState.isHoldAndWinActive = shouldEnterRespinRound

        if (shouldPlayHoldAndWinTransition) {
            this._model.isBonusGameNow = true
            this._stateMachine.setState(GameStatesEnum.HOLD_AND_WIN_INTRO_STATE)
            return
        }

        this.dispatchSpin(spinBet)
    }

    private dispatchSpin(spinBet: number): void {
        if (this._model.spinState.isHoldAndWinActive) {
            ;(GameSignals as any).holdAndWinStartSpin?.emit()
        }

        GameSignals.startSpin.emit(spinBet)

        this.end()
    }
    public end = () => {
        this._stateMachine.setState(GameStatesEnum.GET_SPIN_RESPONSE_STATE)
    }

    public cleanUp() {
        // empty
    }
}
